import React, {
  useState,
  FunctionComponent,
  SyntheticEvent,
} from 'react';

import { ActionsDropdown } from '@components/library/dropdown/index';
import { ActionDropdownItem } from '@components/library/dropdown_item/index';
import SettingsModal from './SettingsModal';
import DeleteModal from './DeleteModal';

interface CardActionsProps {
  brandguideKey: string;
}

const CardActions: FunctionComponent<CardActionsProps> = ({
  brandguideKey
}) => {
  const [closeDropdown, setCloseDropdown] = useState(false);
  const [showSettingsModal, setShowSettingsModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const openSettingsModal = (_: string, e: SyntheticEvent): void => {
    e.preventDefault();
    setShowSettingsModal(true);
  };

  // Commenting out this method for now - in order to implement, need to implement the following to Brandguides:
  //   - include Discard::Model
  //   - add ':deleted_at' column
  //
  // const openDeleteModal = (_: string, e: SyntheticEvent): void => {
  //   e.preventDefault();
  //   setShowDeleteModal(true);
  // };

  return (
    <>
      <ActionsDropdown
        className="brandguide-card-actions"
        closeCallback={(): void => setCloseDropdown(false)}
        closeDropdown={closeDropdown}
        openOnClick={false}
        openOnHover
        userDevice={BFG?.currentUser?.device}
      >
        <ActionDropdownItem
          icon="bff-settings"
          key="edit-brandguide-settings"
          name="edit-brandguide-settings"
          onChoose={openSettingsModal}
        >
          {bfTranslate("Settings")}
        </ActionDropdownItem>
        {/* Commenting out for now - in order to implement, need to implement the following to Brandguides:
          - include Discard::Model
          - add ':deleted_at' column

        <ActionDropdownItem
          icon="bff-trash"
          isWarningItem
          key="delete-brandguide"
          name="delete-brandguide"
          onChoose={openDeleteModal}
        >
          {bfTranslate("Delete Brandguide")}
        </ActionDropdownItem> */}
      </ActionsDropdown>
      {showSettingsModal && (
        <SettingsModal
          brandguideKey={brandguideKey}
          closeModal={(): void => setShowSettingsModal(false)}
        />
      )}
      {showDeleteModal && (
        <DeleteModal
          brandguideKey={brandguideKey}
          closeModal={(): void => setShowDeleteModal(false)}
        />
      )}
    </>
  );
};

export default CardActions;
